import script from "./FosilesView.vue?vue&type=script&setup=true&lang=js"
export * from "./FosilesView.vue?vue&type=script&setup=true&lang=js"

import "./FosilesView.vue?vue&type=style&index=0&id=2a22f097&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a22f097"]])

export default __exports__